<template>
  <button class="md:w-auto" @click='$emit("click", type)' :class='isSelectedClasses'>
    <div :class="!image ? 'pbc-component-link-or-transform-button--parent' : 'pbc-component-link-or-transform-card--parent'">
      <div class="pbc-component-link-or-transform-buton--icon pbc-add-component-type-icon-parent">
        <component v-if='!image' :is='icon' class="pbc-add-component-type-icon" :size='32'/>
        <img v-else :src='imageUrl' class='-mt-1 -mb-1 rounded-full object-contain w-10 h-10' />
      </div>
      <div class="pbc-component-link-or-transform-button--title">
        {{text}}
      </div>
    </div>
    <div class="pbc-component-link-or-transform-button--description">
      {{description}}
    </div>
    <transition name="slide-right">
      <button v-if='!showDone && isSelected' class="pbc-component-link-or-transform-quick-button" @click='$emit("next")'>
        <chevron-right class="w-full mx-auto self-center" :size='48' />
        <div class="text-xs -ml-6 mr-6 self-center">Next</div>
      </button>
      <button v-if='showDone && isSelected' class="pbc-component-link-or-transform-quick-button" @click='$emit("next")'>
        <check class="w-full mx-auto self-center" :size='32' />
        <div class="text-xs -ml-4 mr-4 self-center">Done</div>
      </button>
    </transition>
  </button>

</template>
<script>
import Check from '@icons/Check.vue';
import ChevronRight from '@icons/ChevronRight.vue';
export default {
  inject: ['api'],
  props: {
    text: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    icon: {
      type: Object,
      required: true
    },
    image: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    showDone: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ChevronRight,
    Check
  },
  computed: {
    isSelectedClasses() {
      let classes = []; 
      if (!this.image) {
        classes.push('pbc-component-link-or-transform-button');
      } else {
        classes.push('pbc-component-link-or-transform-card');
      }
      
      if (this.isSelected) {
        classes = classes.concat(['border-solid border-blue-400 border-4 bg-blue-200 relative']);
      } else {
      }
      return classes;
    },
    imageUrl() {
      return this.api.makeImageUrlEditor(this.image);
    }
  }
}
</script>
